module.exports = __webpack_public_path__ + "static/media/tabla.b8c557a3.svg";